(function ($, Drupal, once) {
Drupal.behaviors.main_menu = {
  attach: function (context, settings, ) {
    'use strict';

    // Set 'document' to 'context' if Drupal
    var topLevelLink = context.querySelectorAll('.main-menu__link--with-sub');
    console.log('js called');
    var className = 'is-active';

    for (var i = 0; i < topLevelLink.length; i++) {
      $(once("events", topLevelLink[i])).click(function (e) {
      // topLevelLink[i].addEventListener('click', function (e) {
        // Add is-active class
        let listItem = this.parentNode;
        let subNav = listItem.querySelector('ul');

        listItem.classList.toggle(className);

        // Reposition menu to fit in screen
        if (listItem.classList.contains(className)) {
          let subNavStyleLeft = parseInt(window.getComputedStyle(subNav).getPropertyValue('left'), 10);
          let subNavRect = subNav.getBoundingClientRect();
          let viewportRect = document.body.getBoundingClientRect();

          if (subNavRect.right > viewportRect.width - 18) {
            subNav.style.left = (subNavStyleLeft - (subNavRect.right - (viewportRect.width - 18))) + "px";
          }
        }

        // Collapse sibling dropdowns
        for (var i = 0; i < topLevelLink.length; i++) {
          if (topLevelLink[i] != this && topLevelLink[i].parentNode.classList.contains(className)) {
            topLevelLink[i].parentNode.classList.remove(className);
          }
        }

        e.preventDefault();
      });
    }
  }
};
})(jQuery, Drupal, once);
